/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSubscriptionDetailsDigitalHistoryItem as ResolvedStandaloneSubscriptionDetailsDigitalHistoryItem } from 'base/components/standalone/SubscriptionDetails/Digital/History/Item';

export const SubscriptionDetailsDigitalHistoryItem: typeof ResolvedStandaloneSubscriptionDetailsDigitalHistoryItem = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSubscriptionDetailsDigitalHistoryItem {...props} />
        </ErrorBoundary>
    );
});

export type SubscriptionDetailsDigitalHistoryItemProps = PropsFromComponent<typeof SubscriptionDetailsDigitalHistoryItem>;

/** @deprecated Use slot architecture instead */
export const SubscriptionDetailsDigitalHistoryItemWith = (extras: DynamicStandaloneExtras): typeof SubscriptionDetailsDigitalHistoryItem => {
    return function SubscriptionDetailsDigitalHistoryItem(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SubscriptionDetailsDigitalHistoryItem');
        return <ResolvedStandaloneSubscriptionDetailsDigitalHistoryItem {...mergeProps({ options: { theme } }, props)} />;
    }
}